import React from 'react'
import "./ServiceContent.css"
import { Link } from 'react-router-dom'

export default function Krania() {
  return (
    <>
        <header id='Header_palvelut'>
            <img src={ process.env.PUBLIC_URL + '/assets/images/sh-vastaanotto.jpg'} alt='selkähieronta' className='headerpicture palvelut' />
            <div className='palvelutheadershadow'>
                <h1>Kraniosakraali-<br/>terapia</h1>
            </div>
        </header>
        <div className='wrapper'>
            <div className='page-bodytext'>
                <h3>Keho muistaa enemmän kuin mieli kertoo.</h3>
                <p>Tiesitkö, että keho muistaa kaiken. Kehon muisti kantaa enemmän
                 kuin sanat osaavat kertoa.  Kraniosakraaliterapian avulla autetaan 
                 kehoa muistamaan ja vapauttamaan ongelmien juurisyitä hellästi ja 
                 syvällisesti - sen mikä on valmis tulemaan hoidetuksi- kuulluksi ja 
                 kohdatuksi, riippumatta siitä onko syy fyysinen, psyykkinen vai emotionaalinen.</p>
                <p>Kraniosakraaliterapia (CST) on hellävarainen, käsin suoritettava hierontatekniikka. Siinä käytetään kevyttä kosketusta vapauttamaan jännitystä koko kehon kattavasta sidekudosverkostossa (faskia).</p>
                <p>Ihmiskeho on rakenteellisesti ja toiminnallisesti toisiinsa kytkeytynyt. Tämä tarkoittaa, että yksi kehon alue voi vaikuttaa toiseen. Kraniosakraaliterapian tavoitteena on jännityksen lievittäminen, jonka avulla kehon eri osat alkavat toimia paremmin ja keho pääsee toteuttamaan niin itse sääntelyä kuin itsekorjaamisjärjestelmäänsä paremmin.</p>
                <p>Kraniosakraaliterapian avulla saadaan pitkäkestoista muutosta kohti hyvää oloa ja kokonaisvaltaista hyvinvointia.  Kraniosakraaliterapiaa voi tehdä kaiken ikäisille.</p>
                <div className='page-sidebar'>
                    <h3>Kraniosakraaliterapia voi auttaa seuraaviin oireisiin:<br/><br/></h3>
                    <ul>
                        <li>Päänsäryt ja migreenit</li>
                        <li>Stressi ja ahdistus</li>
                        <li>Selkä- ja niskakivut</li>
                        <li>Uni- ja keskittymisongelmat</li>
                        <li>Traumat ja posttraumaattinen stressihäiriö</li>
                        <li>Fibromyalgia</li>
                        <li>Kipuoireyhtymät ja krooninen kipu</li>
                        <li>Tietyt neurologiset häiriöt</li>
                        <li>Syöpähoidon sivuvaikutukset</li>
                        <li>Aivotärähdyksen jälkeinen oireyhtymä</li>
                        <li>Skolioosi</li>
                        <li>Aivohalvaus</li>
                        <li>Leukanivelen ongelmat</li>
                        <li>Neuropsykologiset oireyhtymät</li>
                    </ul>
                </div>
                <p><Link to="/otayhteytta">Ota rohkeasti yhteyttä.</Link></p>
            </div>    
        </div>
    </>
  )
}
